var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayout',{attrs:{"menu-list":_vm.list,"img":require('@assets/images/elite/banner@2.png'),"custom-class":"isStyleWhite"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }